import store from 'store'

/**
 * Obtiene el usuario actual desde el estado de Redux
 * @returns {object|null} Usuario o null si no está autenticado
 */
export const getUser = () => {
  const state = store.getState()
  return state.user.auth.user || null
}

/**
 * Obtiene el ID del usuario actual desde el estado de Redux
 * @returns {number|null} ID del usuario o null si no está autenticado
 */
export const getUserId = () => {
  return getUser()?.id || null
}

/**
 * Obtiene el nombre corto del usuario actual desde el estado de Redux
 * @returns {string|null} Nombre corto del usuario o null si no está autenticado
 */
export const getUserShortName = () => {
  return getUser()?.short_name || null
}

/**
 * Obtiene el Rol del usuario actual desde el estado de Redux
 * @returns {string|null} Rol del usuario o null si no está autenticado
 */
export const getUserRole = () => {
  return getUser()?.rol || null
}

/**
 * Obtiene el establecimiento del usuario actual desde el estado de Redux
 * @returns {object|null} Establecimiento del usuario o null si no está autenticado
 */
export const getUserEstablishment = () => {
  return getUser()?.establecimiento || null
}

export const getUserEstablishmentRuc = () => {
  return getUserEstablishment()?.numero_documento || null
}

/**
 * Obtiene la sucursal del usuario actual desde el estado de Redux
 * @returns {object|null} Sucursal del usuario o null si no está autenticado
 */
export const getUserBranch = () => {
  return getUser()?.sucursal || null
}

/**
 * Obtiene el ID de la sucursal del usuario actual desde el estado de Redux
 * @returns {number|null} ID de la sucursal o null si no está autenticado
 */
export const getUserBranchId = () => {
  return getUserBranch()?.sucursal_id || null
}

/**
 * Obtiene el nombre de la sucursal del usuario actual desde el estado de Redux
 * @returns {string|null} Nombre de la sucursal o null si no está autenticado
 */
export const getUserBranchName = () => {
  return getUserBranch()?.sucursal || null
}

/**
 * Obtiene el almacén del usuario actual desde el estado de Redux
 * @returns {object|null} Almacén del usuario o null si no está autenticado
 */
export const getUserStore = () => {
  return getUser()?.almacen || null
}

/**
 * Obtiene el ID del almacén del usuario actual desde el estado de Redux
 * @returns {number|null} ID del almacén o null si no está autenticado
 */
export const getUserStoreId = () => {
  return getUserStore()?.almacen_id || null
}
